import styled from 'styled-components';

export const ConsentBannerWrapper = styled.div`
  & button:focus {
    outline-style: auto;
  }
`;
